import React, { forwardRef } from "react";
import cn from "classnames";

import { RegularText, MediumText } from "components/Text";
import { normalizeDecimalInput, toNumberInputValue } from "utils/numberInput";

import styles from "./styles.module.scss";

/**
 * Единый инпут с опциональным лейблом и выводом ошибки.
 * labelPosition: left | top
 *
 * type="number" рендерится как text+inputMode=decimal без browser validation
 * «invalid number»; значение санитизируется, запятая → точка.
 */
export const Input = forwardRef(function Input(
  {
    label,
    labelVariant = "medium",
    labelPosition = "left",
    labelWidth,
    error,
    className,
    containerClassName,
    inputWidth,
    type = "text",
    value,
    onChange,
    inputMode,
    ...rest
  },
  ref
) {
  const LabelComponent = labelVariant === "regular" ? RegularText : MediumText;
  const isNumeric = type === "number";

  const handleChange =
    isNumeric && onChange
      ? (ev) => {
          onChange({
            ...ev,
            target: {
              ...ev.target,
              value: normalizeDecimalInput(ev.target.value),
            },
          });
        }
      : onChange;

  return (
    <div
      className={cn(
        styles.container,
        labelPosition === "top" ? styles.vertical : styles.horizontal,
        containerClassName
      )}
    >
      {!!label && (
        <LabelComponent
          className={styles.label}
          style={labelWidth ? { width: labelWidth, flexShrink: 0 } : undefined}
        >
          {String(label).replace(/:$/, "")}:
        </LabelComponent>
      )}
      <div className={styles.inputWrapper} style={{ width: inputWidth }}>
        <input
          ref={ref}
          type={isNumeric ? "text" : type}
          inputMode={isNumeric ? "decimal" : inputMode}
          className={cn(styles.input, className, {
            [styles.errorBorder]: !!error,
          })}
          value={isNumeric ? toNumberInputValue(value) : value}
          onChange={handleChange}
          {...rest}
        />
        {!!error && typeof error === "string" && (
          <span className={styles.errorText}>{error}</span>
        )}
      </div>
    </div>
  );
});
